module.exports = __webpack_public_path__ + "static/assets/993a0700d8a0972d309307b0a4688ed7.svg";